import { config as defaultConfig } from "../../default/Kambi/Config.resource";

const pokerUrl = "/play-poker-online";

const pokerHistoryLinks = {
  da: `${pokerUrl}/app/pokerhistorik/`,
  deu: `${pokerUrl}/app/pokerverlauf/`,
  en: `${pokerUrl}/app/poker-history/`,
  es: `${pokerUrl}/app/historial-de-poker/`,
  fi: `${pokerUrl}/app/pokeririhistoria/`,
  fr: `${pokerUrl}/app/historique-de-poker/`,
  it: `${pokerUrl}/app/cronologia-poker/`,
  pt: `${pokerUrl}/app/historico-de-poker/`,
  ro: `${pokerUrl}/app/istoric-poker/`,
  ru: `${pokerUrl}/app/poker-history/`,
  sv: `${pokerUrl}/app/pokerhistorik/`,
  br: `${pokerUrl}/app/historico-de-poker/`,
  ua: `${pokerUrl}/app/poker-history/`
};

export const links = {
  howToPlay: `${pokerUrl}/how-to-play-poker/`,
  games: `${pokerUrl}/poker-games/`,
  specialOffers: `${pokerUrl}/poker-promotions/`,
  tournamentInfo: `${pokerUrl}/poker-tournaments/`,
  realMoneyPoker: `${pokerUrl}/real-money-poker/`,
  eMagazine: `/magazine/`,
  pokerUrl: `${pokerUrl}/`,
  casinoUrl: "https://www.888casino.com/",
  casinoUrlAuthenticated: "https://casino-www.888poker.com/",
  sportUrl: "https://www.888sport.com/",
  sportUrlAuthenticated: "https://poker.888sport.com/",
  myGameHistory: `${pokerUrl}/app/poker-history/`,
  depositAndCashout: `${pokerUrl}/real-money-poker/deposit/`,
  aboutUs: `${pokerUrl}/about-us/`,
  responsibleGaming: `https://www.888poker.com/responsible-gaming/`,
  inviteAFriend: `${pokerUrl}/poker-promotions/invite-a-friend/iaf.htm`,
  pokerHistoryLinks
};

export const config = {
  ...defaultConfig,
  logo: "poker_logo",
  logoMobile: "poker_logo_mobile",
  gameHeaderIcons: []
};
